import { Component } from "react"
import PropTypes from "prop-types"
import TransactionLogRow from "./transaction_log_row"

import "../dynamic_applet.scss"

export default class TransactionLogTable extends Component {
  render() {
    return (
      <section>
        <div styleName="dynamic_applet logs" className="partner-tools-body">
          <div styleName="logs-table" className="health-logs">
            <header>
              <div styleName="logs-column logs-column-header">Time</div>
              <div styleName="logs-column logs-column-header">Request</div>
              <div styleName="logs-column logs-column-header">Task</div>
              <div styleName="logs-column logs-column-header">Result</div>
            </header>
            <div className="health-logs-content">
              {this.props.data.map((row, i) => (
                <TransactionLogRow transaction={row} key={i} />
              ))}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

TransactionLogTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
}
